import classNames from "classnames";
import { useExtraHelper } from "features/option-controls/helpers/useExtraHelper";
import { LayoutGroup, motion } from "framer-motion";
import { forwardRef } from "react";
import type { Swiper as SwiperType } from "swiper";
import { useSlides } from "./helpers/useSlideHelper";

type MobileConfiguratorProgressBarProps = {
  activeIndex: number;
};
export const MobileConfiguratorProgressBar = forwardRef<
  SwiperType | null,
  MobileConfiguratorProgressBarProps
>(({ activeIndex }, ref) => {
  const swiperRef = ref as React.RefObject<SwiperType>;
  const { slides } = useSlides();
  return (
    <LayoutGroup>
      <div className="gg-mx-auto gg-mt-2.5 gg-flex gg-h-12 gg-w-full gg-items-center gg-justify-between gg-border-[0.5px] gg-bg-[#F5F4F7] gg-px-2 gg-py-9">
        {slides.map((slide, index) => {
          const isActive = activeIndex === index;

          return (
            <div
              key={slide.name}
              className="gg-relative gg-flex gg-w-1/5 gg-justify-center"
            >
              <button
                type="button"
                aria-current={isActive ? "step" : undefined}
                onClick={() => swiperRef.current?.slideTo(index)}
                className="gg-flex gg-flex-col gg-items-center gg-justify-center"
              >
                <div
                  className={classNames(
                    "gg-grid gg-aspect-square gg-w-7 gg-place-items-center gg-rounded-full gg-text-[10px] gg-font-bold gg-transition gg-duration-300 gg-ease-in-out",
                    {
                      "gg-bg-dark-blue gg-text-white": isActive,
                      "gg-bg-[#EAE9ED] gg-text-[#292747]/80": !isActive,
                    },
                  )}
                >
                  {index + 1}
                </div>
                <p className="gg-mt-1 gg-text-[10px] gg-font-bold gg-text-secondary-text">
                  {slide.name}
                </p>
              </button>
              {isActive && (
                <motion.div
                  layoutId="highlight"
                  className="gg-absolute gg-inset-x-0 -gg-bottom-[6px] gg-h-[1.5px] gg-w-full gg-bg-dark-blue"
                ></motion.div>
              )}
            </div>
          );
        })}
      </div>
    </LayoutGroup>
  );
});
